import { DocumentsUpload, Label } from '@pay-com/components'
import {
  Controller,
  FieldPath,
  FieldValues,
  useFormContext
} from 'react-hook-form'

interface ControlledFileUploadProps<T extends FieldValues> {
  name: FieldPath<T>
  label?: string
  multiple?: boolean
  maxFiles?: number
  maxSize?: number
  disabled?: boolean
  isLoading?: boolean
  className?: string
  token?: string
  reference?: string
}

export const ControlledFileUpload = <T extends FieldValues>({
  name,
  label,
  multiple,
  maxSize,
  disabled,
  isLoading,
  maxFiles,
  className,
  token,
  reference
}: ControlledFileUploadProps<T>) => {
  const { control } = useFormContext<T>()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const { error } = fieldState

        return (
          <div className={className}>
            {label && <Label label={label} size="small" />}
            <DocumentsUpload
              type="ONBOARDING"
              token={token ?? ''}
              reference={reference ?? ''}
              multiple={multiple ?? false}
              maxSizeMB={maxSize ?? 50}
              autoUpload
              onSuccess={(ids: string[]) => {
                if (multiple) {
                  field.onChange([...new Set([...(field.value || []), ...ids])])
                } else {
                  field.onChange(ids[0] ?? null)
                }
              }}
              onRemove={(doc: { id?: string | null }) => {
                if (!doc?.id) return
                if (multiple) {
                  const current = Array.isArray(field.value) ? field.value : []
                  field.onChange(current.filter((id: string) => id !== doc.id))
                } else {
                  field.onChange(null)
                }
              }}
              onError={(err: unknown) => {
                console.error('Upload failed:', err)
              }}
            />
            {error?.message && (
              <span className="mt-1 text-xs text-red-500">{error.message}</span>
            )}
          </div>
        )
      }}
    />
  )
}
